import { useContext, useCallback, useMemo } from 'react'
import { FormattedMessage } from 'react-intl'

import Pane from 'components/Common/Pane'
import Heading from 'LuxKit/Typography/Heading'
import BodyText from 'LuxKit/Typography/BodyText'
import Group from 'components/utils/Group'
import ModalContext from 'contexts/ModalContext'
import TextButton from 'LuxKit/Button/TextButton'
import Image from 'components/Common/Image'
import InlineBulletList from 'components/utils/InlineBulletList'
import CruiseShipAmenitiesModal from './CruiseShipAmenitiesModal'

interface Props {
  amenity: App.CruiseShipAmenity
}

function CruiseShipAmenitiesItem({
  amenity,
}: Props) {
  const showModal = useContext(ModalContext)

  const showReadMore = useMemo(() => {
    return !!amenity.description && amenity.description.length > 100
  }, [amenity.description])

  const openModal = useCallback(() => {
    showModal(<CruiseShipAmenitiesModal amenity={amenity} />)
  }, [showModal, amenity])

  return <Pane border="light-foreground" padding={20}>
    <Group direction="horizontal" gap={12}>
      {!!amenity.imageId && <Image id={amenity.imageId} width={200} height={150} />}

      <Group direction="vertical" gap={12}>
        <Heading variant="heading5">{amenity.title}</Heading>

        <Group direction="vertical" horizontalAlign="start">
          <BodyText variant="medium" weight="normal" lineClamp={2}>{amenity.description}</BodyText>

          {!amenity.description && amenity.listItems && <InlineBulletList>
            {amenity.listItems.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </InlineBulletList>}

          {showReadMore && (
            <TextButton
              kind="tertiary"
              horizontalOutdent="start"
              onClick={openModal}
            >
              <FormattedMessage
                id="Lr41zuYCsvZGnLSs2uOQ"
                defaultMessage="Read more"
                description="Action button label to read more about amenity in the cruises section"
              />
            </TextButton>
          )}
        </Group>
      </Group>
    </Group>
  </Pane>
}

export default CruiseShipAmenitiesItem
